module.exports = __webpack_public_path__ + "static/media/HOW YOU CAN INVOICE SCHOOL BASED ON THE COMMISSION.897dbac4.png";